export default "__VITE_ASSET__e55a5d72__"